<template>
  <tr>
    <td>
      <div class="event--name">{{ event.event_name }}</div>
    </td>
    <td>{{ event.event_description }}</td>
    <td>
      <span v-if="isGlobal" class="badge badge--global">
        {{ $t('EVENTS.LIST.GLOBAL') }}
      </span>
      <span v-else class="badge badge--account">
        {{ $t('EVENTS.LIST.ACCOUNT') }}
      </span>
    </td>
    <td>
      <woot-switch
        v-if="!isGlobal"
        size="small"
        class="auto-offline--switch"
        :value="event.is_active"
        @input="onToggleActive"
      />
        <span v-else>
            {{ event.is_active ? $t('EVENTS.LIST.ACTIVE') : $t('EVENTS.LIST.INACTIVE') }}
        </span>
    </td>
    <td>{{ formatDate(event.created_at) }}</td>
    <td class="button-wrapper">
      <woot-button
        v-if="!isGlobal"
        v-tooltip.top="$t('EVENTS.EDIT.BUTTON_TEXT')"
        variant="smooth"
        size="tiny"
        color-scheme="secondary"
        icon="edit"
        @click="$emit('edit', event)"
      />
      <woot-button
        v-if="!isGlobal"
        v-tooltip.top="$t('EVENTS.DELETE.BUTTON_TEXT')"
        variant="smooth"
        color-scheme="alert"
        size="tiny"
        icon="dismiss-circle"
        @click="$emit('delete', event, index)"
      />
    </td>
  </tr>
</template>

<script>
import format from 'date-fns/format';

export default {
  props: {
    event: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  computed: {
    isGlobal() {
      return this.event.account_id === 0;
    },
  },
  methods: {
    formatDate(dateString) {
      return format(new Date(dateString), 'dd/MM/yyyy - HH:mm');
    },
    onToggleActive() {
      this.$emit('toggle-active', this.event);
    },
  },
};
</script>

<style scoped lang="scss">
.event--name {
  color: var(--s-700);
  font-weight: var(--font-weight-medium);
  word-break: break-word;
}

.button-wrapper {
  max-width: var(--space-mega);
  min-width: auto;

  button:nth-child(2) {
    margin-left: var(--space-normal);
  }
}

.badge {
  padding: var(--space-micro) var(--space-small);
  border-radius: var(--border-radius-small);
  font-size: var(--font-size-mini);
  font-weight: var(--font-weight-medium);

  &--global {
    background-color: var(--w-100);
    color: var(--w-700);
  }

  &--account {
    background-color: var(--s-100);
    color: var(--s-700);
  }
}
</style>
